import { render, staticRenderFns } from "./big_list.vue?vue&type=template&id=527c42b4&scoped=true&"
import script from "./big_list.vue?vue&type=script&lang=js&"
export * from "./big_list.vue?vue&type=script&lang=js&"
import style0 from "./big_list.vue?vue&type=style&index=0&id=527c42b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c42b4",
  null
  
)

export default component.exports